module.exports = __webpack_public_path__ + "media/recipes/13-38a7d1db.png";